import { jsx as _jsx } from "react/jsx-runtime";
import '../../assets/saas/molecules/_loader-progress-bar.scss';
const LoaderProgressBar = () => {
    return (_jsx("div", { className: "loader-progress", children: _jsx("div", { className: "loader-progress__bar", children: " \u00A0 " }) }));
};
export default LoaderProgressBar;
